import { useCallback, useEffect, useState } from 'react'
import { ShieldAlert, X } from 'lucide-react'
import { platformApi } from '@/services/platform/platform.http'
import { clearSupportContext, readSupportContext, SUPPORT_CONTEXT_EVENT, type ActiveSupportContext } from '@/security/supportContext'

export default function SupportAccessBanner() {
  const [context, setContext] = useState<ActiveSupportContext | null>(() => readSupportContext())
  const refresh = useCallback(() => setContext(readSupportContext()), [])
  useEffect(() => {
    window.addEventListener(SUPPORT_CONTEXT_EVENT, refresh)
    const timer = window.setInterval(refresh, 15000)
    return () => { window.removeEventListener(SUPPORT_CONTEXT_EVENT, refresh); window.clearInterval(timer) }
  }, [refresh])
  if (!context) return null

  const exit = async () => {
    try { await platformApi.revokeSupportSession(context.sessionId, 'Operator exited support access') }
    finally { clearSupportContext() }
  }
  return <div role="alert" className="mb-6 flex items-center justify-between gap-4 rounded-lg border-2 border-amber-500 bg-amber-50 p-4 text-amber-950">
    <div className="flex items-start gap-3"><ShieldAlert className="mt-0.5 h-5 w-5 shrink-0" />
      <div><strong>SUPPORT ACCESS ACTIVE</strong><div className="text-sm">Tenant {context.targetTenantId} · {context.ticket} · {context.permissions.includes('txh.support.data.write') ? 'read/write' : 'read-only'} · expires {new Date(context.expiresAt).toLocaleString()}</div></div>
    </div>
    <button className="btn border-amber-700" onClick={() => void exit()}><X className="mr-1 inline h-4 w-4" />Exit and revoke</button>
  </div>
}
